.card {
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.card:hover {
  border-color: rgba(255, 255, 255, 0.3);
}

/* The cards are tab stops (a radio group): keyboard focus must be seen, not only the hover. */
.card:focus-visible {
  outline: 2px solid var(--accent-color, #c8ff00);
  outline-offset: 2px;
}

.selected {
  border-color: var(--accent-color, #c8ff00);
  background: rgba(255, 255, 255, 0.08);
}

/* Shown but not selectable: the caption says why (the chain registry, see escrowOffer.ts). */
.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.disabled:hover {
  border-color: rgba(255, 255, 255, 0.15);
}
